import { render, staticRenderFns } from "./RelatedCourseTable.vue?vue&type=template&id=7fa9f476&scoped=true"
import script from "./RelatedCourseTable.vue?vue&type=script&lang=js"
export * from "./RelatedCourseTable.vue?vue&type=script&lang=js"
import style0 from "./RelatedCourseTable.vue?vue&type=style&index=0&id=7fa9f476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9f476",
  null
  
)

export default component.exports